// @core/api/endpoints/notifications/get_tenant_settings.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTenantSettingsResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get tenant notification settings
 * Retrieves the notification settings configured for a tenant. Tenant settings define available channels, mandatory categories, branding, and rate limits.
 */
export async function GetTenantSettings(
  tenant_id: string,
  options?: RequestOptions
): Promise<GetTenantSettingsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/settings`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<GetTenantSettingsResponse>(requestPath, { ...requestOptions });
}
